"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoEditorSDKProvidedForEditorSDKMode = void 0;
var tslib_1 = require("tslib");
var NoEditorSDKProvidedForEditorSDKMode = /** @class */ (function (_super) {
    tslib_1.__extends(NoEditorSDKProvidedForEditorSDKMode, _super);
    function NoEditorSDKProvidedForEditorSDKMode() {
        var _newTarget = this.constructor;
        var _this = _super.call(this, "\nNo `editorSDK` was passed to TPASettingsProvider.\nIn order to work with tpa-settings in editorSDK mode, you have to pass the Editor SDK to the Settings panel.\n") || this;
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return NoEditorSDKProvidedForEditorSDKMode;
}(Error));
exports.NoEditorSDKProvidedForEditorSDKMode = NoEditorSDKProvidedForEditorSDKMode;
//# sourceMappingURL=NoEditorSDKProvidedForEditorSDKMode.js.map